import { initReactI18next } from 'react-i18next';
import i18n from 'i18next';

import accountSwitchEN from './locales/en/account-switch.en.json';
import askToJoinEN from './locales/en/ask-to-join.en.json';
import askXEN from './locales/en/askx.en.json';
import authEN from './locales/en/auth.en.json';
import companiesEN from './locales/en/companies.en.json';
import contactInnovationTeamEN from './locales/en/contact-innovation-team.en.json';
import contactsEN from './locales/en/contacts.json';
import datesEN from './locales/en/dates.en.json';
import defaultEN from './locales/en/default.en.json';
import exploreEN from './locales/en/explore.en.json';
import homepageEN from './locales/en/homepage.en.json';
import spotlightEN from './locales/en/spotlight.en.json';
import feedEN from './locales/en/feed.en.json';
import projectsEN from './locales/en/projects.en.json';
import requestProjectEN from './locales/en/request-project.en.json';
import settingsEN from './locales/en/settings.en.json';
import tagsEN from './locales/en/tags.json';
import teamsEN from './locales/en/teams.en.json';
import notificationEN from './locales/en/notification.en.json';

export const translations = {
  en: {
    'account-switch': accountSwitchEN,
    'ask-to-join': askToJoinEN,
    askX: askXEN,
    auth: authEN,
    companies: companiesEN,
    'contact-innovation-team': contactInnovationTeamEN,
    contacts: contactsEN,
    dates: datesEN,
    default: defaultEN,
    explore: exploreEN,
    homepage: homepageEN,
    spotlight: spotlightEN,
    feed: feedEN,
    notification: notificationEN,
    projects: projectsEN,
    'request-project': requestProjectEN,
    settings: settingsEN,
    teams: teamsEN,
    tags: tagsEN,
  },
};

// eslint-disable-next-line @typescript-eslint/no-floating-promises
i18n.use(initReactI18next).init({
  resources: translations,
  ns: [
    'account-switch',
    'ask-to-join',
    'askX',
    'auth',
    'companies',
    'contact-innovation-team',
    'contacts',
    'default',
    'dates',
    'explore',
    'homepage',
    'spotlight',
    'feed',
    'notification',
    'projects',
    'request-project',
    'settings',
    'teams',
    'tags',
  ],
  lng: 'en',
  nsSeparator: ':',
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
